(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tbv-campaign-hero"] && !Shopify.designMode) return;
  try {
    
  function initializeTbvHeroCarousel(carousel) {
    if (carousel.dataset.initialized === 'true') return;
    carousel.dataset.initialized = 'true';

    const slides = Array.from(carousel.querySelectorAll('[data-tbv-hero-slide]'));
    const dots = Array.from(carousel.querySelectorAll('[data-tbv-hero-dot]'));
    const previousButton = carousel.querySelector('[data-tbv-hero-previous]');
    const nextButton = carousel.querySelector('[data-tbv-hero-next]');
    const toggleButton = carousel.querySelector('[data-tbv-hero-toggle]');
    const toggleIcon = carousel.querySelector('[data-tbv-hero-toggle-icon]');
    const status = carousel.querySelector('[data-tbv-hero-status]');
    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const autoplayEnabled = carousel.dataset.autoplay === 'true' && !prefersReducedMotion.matches;
    const interval = Math.max(Number(carousel.dataset.interval) || 7000, 4000);
    let activeIndex = 0;
    let timer;
    let pausedByUser = false;
    let pointerStartX = null;

    function announce(index) {
      if (!status) return;
      const name = slides[index].dataset.slideName;
      status.textContent = name || `${index + 1} / ${slides.length}`;
    }

    function showSlide(index, shouldAnnounce = true) {
      activeIndex = (index + slides.length) % slides.length;
      slides.forEach((slide, slideIndex) => {
        const isActive = slideIndex === activeIndex;
        slide.classList.toggle('is-active', isActive);
        slide.setAttribute('aria-hidden', String(!isActive));
      });
      dots.forEach((dot, dotIndex) => {
        const isActive = dotIndex === activeIndex;
        dot.classList.toggle('is-active', isActive);
        dot.setAttribute('aria-current', String(isActive));
      });
      if (shouldAnnounce) announce(activeIndex);
    }

    function stopTimer() {
      window.clearInterval(timer);
      timer = undefined;
    }

    function startTimer() {
      stopTimer();
      if (!autoplayEnabled || pausedByUser || document.hidden) return;
      timer = window.setInterval(() => showSlide(activeIndex + 1, false), interval);
    }

    function setPausedState(paused) {
      pausedByUser = paused;
      if (toggleButton) {
        const pauseLabel = toggleButton.dataset.pauseLabel;
        const playLabel = toggleButton.dataset.playLabel;
        toggleButton.setAttribute('aria-pressed', String(paused));
        toggleButton.setAttribute('aria-label', paused ? playLabel : pauseLabel);
      }
      if (toggleIcon) toggleIcon.textContent = paused ? '▶' : 'Ⅱ';
      if (paused) stopTimer();
      else startTimer();
    }

    previousButton?.addEventListener('click', () => {
      showSlide(activeIndex - 1);
      startTimer();
    });
    nextButton?.addEventListener('click', () => {
      showSlide(activeIndex + 1);
      startTimer();
    });
    dots.forEach((dot) => {
      dot.addEventListener('click', () => {
        showSlide(Number(dot.dataset.tbvHeroDot));
        startTimer();
      });
    });
    toggleButton?.addEventListener('click', () => setPausedState(!pausedByUser));

    carousel.addEventListener('pointerdown', (event) => {
      pointerStartX = event.clientX;
    });
    carousel.addEventListener('pointerup', (event) => {
      if (pointerStartX === null) return;
      const distance = event.clientX - pointerStartX;
      pointerStartX = null;
      if (Math.abs(distance) < 50) return;
      showSlide(activeIndex + (distance < 0 ? 1 : -1));
      startTimer();
    });
    carousel.addEventListener('mouseenter', stopTimer);
    carousel.addEventListener('mouseleave', startTimer);
    carousel.addEventListener('focusin', stopTimer);
    carousel.addEventListener('focusout', startTimer);
    document.addEventListener('visibilitychange', startTimer);
    prefersReducedMotion.addEventListener('change', () => {
      if (prefersReducedMotion.matches) stopTimer();
      else startTimer();
    });

    showSlide(0, false);
    startTimer();
  }

  function initializeTbvHeroCarousels(root = document) {
    root.querySelectorAll('[data-tbv-hero-carousel]').forEach(initializeTbvHeroCarousel);
  }

  initializeTbvHeroCarousels();
  document.addEventListener('shopify:section:load', (event) => initializeTbvHeroCarousels(event.target));

  } catch(e) { console.error(e); }
})();
})();
